import { AppLoadingIndicator } from "../../../shared/components/AppLoadingIndicator";
import { TranslationKey } from "../../../shared/i18n/i18n";

type AdminLoadingViewProps = {
  t: (key: TranslationKey) => string;
};

export const AdminLoadingView = ({ t }: AdminLoadingViewProps) => {
  return (
    <main className="admin-page">
      <AppLoadingIndicator
        caption={t("admin.loading")}
        className="admin-loading-shell"
      />
    </main>
  );
};
